export default "__VITE_ASSET__BiEu3gSo__"